import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import VideoSwap from '@src/components/sco/InvestorOutreachLP/components/VideoSwap';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
type RequestAdvisorExampleCardProps = {};
export const RequestAdvisorExampleCard = props => {
  const $ = _c(4);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      url: "https://www.youtube.com/watch?v=23ghmEZQ_Fc&t=279s&ab_channel=Startups.com%21",
      title: "Video 1",
      coverImage: "/assets/graphics/investor-match/pdr-pre-seed-travel.webp"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const videos = t0;
  const t1 = isMobile ? 4 : 0;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = videos.map(_temp);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1) {
    t3 = <Box marginTop={t1} width="full">{t2}</Box>;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(video, index) {
  return <VideoSwap key={index} coverImage={video.coverImage} videoUrl={video.url} />;
}